// extracted by mini-css-extract-plugin
export default {"div":"categoryLink_div__XpY6k","ul":"categoryLink_ul__bNhKb","li":"categoryLink_li__q6Jz-","a":"categoryLink_a__UssgW","error":"categoryLink_error__azXKf"};